export const MIN_PASSWORD_LENGTH = 8;

export const getPasswordChecks = (password = '') => [
  {
    label: `At least ${MIN_PASSWORD_LENGTH} characters`,
    ok: password.length >= MIN_PASSWORD_LENGTH,
  },
  {
    label: 'Contains an uppercase letter',
    ok: /[A-Z]/.test(password),
  },
  {
    label: 'Contains a lowercase letter',
    ok: /[a-z]/.test(password),
  },
  {
    label: 'Contains a number',
    ok: /[0-9]/.test(password),
  },
  {
    label: 'Contains a special character',
    ok: /[!@#$%^&*()_\-+=[\]{};:'",.<>/?\\|`~]/.test(password),
  },
];

export const isPasswordStrong = (password = '') =>
  getPasswordChecks(password).every((check) => check.ok);

export const getPasswordStrength = (password = '') => {
  const passed = getPasswordChecks(password).filter((check) => check.ok).length;
  if (!password) {
    return { score: 0, label: '', color: 'bg-gray-200' };
  }
  if (passed <= 1) {
    return { score: 1, label: 'Very weak', color: 'bg-red-500' };
  }
  if (passed === 2) {
    return { score: 2, label: 'Weak', color: 'bg-orange-500' };
  }
  if (passed === 3) {
    return { score: 3, label: 'Fair', color: 'bg-yellow-500' };
  }
  if (passed === 4) {
    return { score: 4, label: 'Good', color: 'bg-blue-500' };
  }
  return { score: 5, label: 'Strong', color: 'bg-green-500' };
};
